module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("200 Appetizers")]), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Helpful Hints for a Successful\n        Appetizer Party")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("Dips and Spreads ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e100"
    }
  }, [_vm._v("The Ultimate Spinach Artichoke Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e136"
    }
  }, [_vm._v("Rustic Cheese Spread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e166"
    }
  }, [_vm._v("Roasted Garlic Hummus ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e200"
    }
  }, [_vm._v("Caramelized Onion Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e226"
    }
  }, [_vm._v("Savory Lemon Herb Cheesecake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e262"
    }
  }, [_vm._v("Gorgonzola Fruit Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e290"
    }
  }, [_vm._v("Roasted Red Pepper Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e314"
    }
  }, [_vm._v("White Bean and Spinach Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e344"
    }
  }, [_vm._v("Pizza Fondue ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e384"
    }
  }, [_vm._v("Roasted Veggie Spread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e418"
    }
  }, [_vm._v("Cowboy Caviar ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e454"
    }
  }, [_vm._v("Lemon Garlic White Bean Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e482"
    }
  }, [_vm._v("Layered Pesto Torte ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e514"
    }
  }, [_vm._v("Buffalo Style Layered Spread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e540"
    }
  }, [_vm._v("Nutty Olive Spread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e568"
    }
  }, [_vm._v("Pineapple Cheddar Spread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e596"
    }
  }, [_vm._v("Three Step Pate ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e626"
    }
  }, [_vm._v("Pesto Warm Goat Cheese Spread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e658"
    }
  }, [_vm._v("Shrimp Topped Avocado Mousse ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e694"
    }
  }, [_vm._v("Clams Casino Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e736"
    }
  }, [_vm._v("Spanish Fig and Almond Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e766"
    }
  }, [_vm._v("Red Pepper Tapenade ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e792"
    }
  }, [_vm._v("Bombay Red Lentil Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e826"
    }
  }, [_vm._v("Goat Cheese in Grape Leaves ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#d0e866"
    }
  }, [_vm._v("Yucatan Style Seafood Ceviche ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("East Meets West ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e913",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Wonton Kisses ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e950",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Satay Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Pea Pods ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sticky Rice Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maple Bacon Water Chestnuts ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seafood Rangoon Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lettuce Wrap Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Minute Tempura ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("East Meets West Wings ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Samosas ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luau Pork Lettuce Wraps ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vietnamese Pork Crostini ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vietnamese Shaking Beef Kabobs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thai Fish Cake Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1452",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mongolian Meatballs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1492",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Mango Summer Rolls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1521",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peking Duck Pancakes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1553",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese Pork Rolls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1592",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ginger Pork Wontons ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1622",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thai Fresh Rolls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1655",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double Coconut Shrimp ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1699",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple Wontons ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1753",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seafood Spring Roll Cigars ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1796",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salmon Sushi Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1850",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Tuna Sushi Squares ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1887",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Mango Sushi Cakes ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elegant Fare ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1926",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Mini Eclairs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1954",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Pepper Cucumber Cups ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1984",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elegant Ham Sandwich Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Tulips ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Asparagus Spears ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbed Cheese Pepper Wedges ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream Cheese Frosted Rice Cakes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Veggie Flower Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walnut Gorgonzola Pear Wedges ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Butternut Stacks ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pretty Party Pinwheels ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Lime Melon Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roast Beef Wrapped Pearls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wrapped Roasted Pear Wedges ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broiled Shrimp Toasts ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Ricotta Crepe Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cashew Crusted Grapes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cucumber Tea Sandwiches ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheese Tartlets ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2451",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushroom Goat Cheese Puffs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2487",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Almond Apple Rings ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2513",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Salmon Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2547",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lomi Lomi Salmon Spoons ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2581",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clams Casino Flatbreads ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2625",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Carpaccio Cones ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2663",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lobster Mango Cocktail ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2709",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot Pistachio Phyllo Purses ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2739",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Walnut Strawberry Bruschetta ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2783",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bite-Size Crab Cakes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e2819",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indian Spiced Carrot Phyllo Sticks ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Festive Holiday Fare ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2857",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweetheart Beet Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2893",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Salmon Cucumber Hearts ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2913",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easter Egg Tea Sandwiches ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2945",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Cross Bun Sliders ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2985",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St. Paddy’s Irish Boxty Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Cod Potato Fritters ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Beef Pasties ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red, White, and Blueberry Rounds ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Firecracker Popcorn Shrimp ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spider Topped Deviled Eggs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spider Cheese Ball ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jack O’ Lantern Cheese Ball ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkey Cranberry Bruschetta ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Pecan Tartlets ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Rugalach ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday Cranberry Baked Brie ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas Dinner on a Stick ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3433",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Mince Pies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3457",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raspberry Cheese Ball Pinecone ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3481",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goat Cheese Yule Log ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e3507",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gift Wrapped Shrimp Bites ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mediterranean Mix ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3541",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruschetta Trio ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3574",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prosciutto Wrapped Bread Sticks ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3600",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balsamic Chicken Wings ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3628",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antipasto Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3658",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mad Greek Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3690",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Chicken Purses ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3726",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parmesan Zucchini Crisps ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3754",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Ratatouille Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3782",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spinach Feta Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3810",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuscan Stuffed Mushrooms ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3844",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greek Salad Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3868",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiced Toasted Garbanzo Beans ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3894",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sausage Topped Polenta Squares ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3926",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caprese Salad Stacks ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3946",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pesto Stuffed Cherry Tomatoes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e3970",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spaghetti and Meatball Nests ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herb Topped Baked Ricotta ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Bite Calzones ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toasted Ravioli Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Souvlaki Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramelized Onion Focaccia Rounds ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zucchini Pizza Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margherita Panini Wedges ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spinach Feta Triangles ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Mozzarella Tartlets ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Prosciutto Asparagus Spears ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baklava Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e4381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foil Wrapped Baked Feta ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Grill ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Garlic Zucchini Rolls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4439",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Potato Style Rounds ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4467",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shortcut Pesto Breadsticks ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4493",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yucatan Pork Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4521",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Bite Sonoran Hot Dogs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4553",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon Wrapped Jalapeno Shrimp ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4585",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Fruit Flatbread Wedges ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4621",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carne Asada Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4674",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Mushroom Nachos ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4718",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemony Grilled Artichokes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4756",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prosciutto Wrapped Peach Wedges ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4784",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Scallops with Melon Salsa ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4826",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Watermelon Kabobs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4858",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Shrimp Tostada Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4921",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbecue Chicken Lettuce Wraps ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4953",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon and Apricot Jalapeno Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e4984",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Grilled Vegetable Pitas ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e5028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb Lollipops ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e5079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chile Lime Shrimp Skewers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e5117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Bite Fish Tacos ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South of the Border ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jalapeno Bottle Caps ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chili Cornbread Cups ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Empanadas ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guacamole Tortilla Cones ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tostada Cups ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tortilla Spirals ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mole Spiced Pecans ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quesadilla Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Bite Tamale Tartlets ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5445",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chile con Queso Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5479",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Fajitas on a Stick ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Jalapeno Poppers ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5543",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margarita Chicken Lollipops ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5575",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Salsa Cheesecake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5611",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jalapeno Popper Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5633",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everyone’s Favorite Bean Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5657",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jalapeno Corn Cakes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5695",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raspberry Lemon Fruit Nachos ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5727",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queso Fundido ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5765",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Jalapeno Hummus ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5799",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ahi Tostada Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e5845",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carne Asada Flatbreads ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Updated Classics ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e5891",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caesar Salad Crouton Cups ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e5927",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All American Sliders ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e5959",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna Melt Sliders ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e5989",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curly Cheese Straws ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buffalo Chicken Cubes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Skins ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saucy Meatball Lollipops ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nut Crusted Cheese Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Quiche Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deviled Egg Trio ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parmesan Puffs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham and Swiss Twists ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushroom Toasts ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham and Broccoli Cups ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbed Cheddar Mini Scones ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Cheese Sandwich Cubes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twice Baked Baby Potatoes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6450",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheese Stuffed Rice Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6472",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Cordon Bleu Bites ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6504",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Bite Zucchini Frittatas ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6534",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Fried Cheese Balls ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6558",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLT Spirals ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6582",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheddar Crisps ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6620",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goat Cheese Almond Apricots ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6644",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seafood Cocktails ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6668",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Fingerling Potatoes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6696",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Onion Toasts ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e6720",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Herbed Popcorn ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2835850b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 63
// module chunks = 0